module.exports = __webpack_public_path__ + "img/abstracts - grayscale.bcce2838.svg";